import Svg, { Path } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { memo } from 'react';
const SvgIconCheckmarkCircle = (props: SvgProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 0.5C6.71573 0.5 0 7.21573 0 15.5C0 23.7843 6.71573 30.5 15 30.5C23.2843 30.5 30 23.7843 30 15.5C30 7.21573 23.2843 0.5 15 0.5ZM20.3675 10.1033L21.5783 8.90007L23.9999 11.2975L22.789 12.5008C21.2959 13.9878 20.0053 15.3387 18.7072 16.6973C17.394 18.0719 16.0731 19.4545 14.5271 20.9942L13.4143 22.1001L12.2124 21.0915L8.5087 17.9772L7.19987 16.8802L9.40769 14.2878L10.7165 15.3848L13.2004 17.4729C14.205 16.4508 15.1442 15.4725 16.0872 14.4901C17.4381 13.083 18.7968 11.6675 20.3675 10.1033Z"
      fill="currentColor"
    />
  </Svg>
);
const Memo = memo(SvgIconCheckmarkCircle);
export default Memo;
